import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Avatar,
  FormHelperText,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_USER } from "../../Schema/User";
import { translateLauguage } from "../../Function/Translate";
import { SelectMainUser } from "../Include/DynamicSelect";

export default function CreateUser({ open, handleClose, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [img, setImg] = useState({});

  const [mainUserVal, setMainUserVal] = useState({ id: "", title: "" });

  const [createAccountingUser] = useMutation(CREATE_USER, {
    onCompleted: ({ createAccountingUser }) => {
      setLoading(false);
      // console.log("createAccountingUser::", createAccountingUser);
      if (createAccountingUser?.status === true) {
        setAlert(true, "success", createAccountingUser?.message);
        handleClose();
        resetForm();
        setRefetch();
        setMainUserVal({ id: "", title: "" });
      } else {
        setAlert(true, "error", createAccountingUser?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    id: Yup.string().required("require!"),
    role: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      id: "",
      role: "Admin",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      createAccountingUser({
        variables: {
          id: mainUserVal?.id,
          role: values?.role,
        },
      });
    },
  });

  useEffect(() => {
    if (mainUserVal?.id) {
      setFieldValue("id", mainUserVal?.id);
    } else {
      setFieldValue("id", "");
    }
  }, [mainUserVal?.id]);

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_create_user")}
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Stack direction="row" justifyContent="center">
                  <Avatar
                    className="avater-image"
                    src={mainUserVal?.img ? mainUserVal?.img : ""}
                  />
                </Stack>
                <Typography
                  className="field-title"
                  sx={{ textAlign: "center" }}
                >
                  Profile image
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_select_employee")}
                </Typography>
                <SelectMainUser
                  selectedVal={mainUserVal}
                  setSelectedVal={setMainUserVal}
                  setImg={setImg}
                />
                {!!errors.id && touched.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.id}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_role")}
                </Typography>
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={values?.role}
                    onChange={(e) => setFieldValue("role", e.target.value)}
                  >
                    <MenuItem value="Admin">Admin</MenuItem>
                    <MenuItem value="AffairDirector">Affair director</MenuItem>
                    <MenuItem value="HeadOffice">Headffice</MenuItem>
                    <MenuItem value="AccountReceived">
                      Account received
                    </MenuItem>
                    <MenuItem value="AccountPayable">Account payable</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={12} md={6}>
                <Typography className="field-title">
                  {t("thead_password")}
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  type={show ? "text" : "password"}
                  placeholder={t("label_password")}
                  {...getFieldProps("password")}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start" onClick={handleClick}>
                        {show ? (
                          <VisibilityIcon className="viewpw-icon" />
                        ) : (
                          <VisibilityOffIcon className="viewpw-icon" />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className="field-title">
                  {t("thead_confirmpassword")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type={show ? "text" : "password"}
                  placeholder={t("label_confirmpassword")}
                  {...getFieldProps("confirmPassword")}
                  error={Boolean(
                    touched.confirmPassword && errors.confirmPassword
                  )}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                />
              </Grid> */}

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
